export default {
  'booking.totalsales': 'Gesamtumsatz per Zähler',
  'booking.buy_ticket': 'Ticket kaufen',
  'booking.wheretogo': 'Wohin möchte ich gehen?',
  'booking.searchflight': 'Flug suchen',
  'booking.selectflight': 'Wählen Sie Flug',
  'booking.oneway': 'Einweg',
  'booking.onewaytrip': 'Einfache Reise',
  'booking.roundtrip': 'Rundfahrt',
  'booking.multicity': 'Multi Stadt',
  'booking.bestguarantee': 'Beste Tarife werden online garantiert',
  'booking.getdeals': 'Abmachungen  holen',
  'booking.signupnow': 'Jetzt registrieren',
  'booking.from': 'von',
  'booking.to': 'bis',
  'booking.guest': 'Gast',
  'booking.city': 'Stadt',
  'booking.country': 'Land',
  'booking.Adult': 'Erwachsener',
  'booking.adult': 'Erwachsener',
  'booking.Child (Age 2-12)': 'Kind (Alter 2 - 12)',
  'booking.Infant (Age 0-2)': 'Säugling (Alter 0 - 2)',
  'booking.guestsandcities': 'Gast und Städte',
  'booking.startover': 'Von vorn anfangen',
  'booking.showmoredate': 'Mehr Datum anzeigen',
  'booking.selectdate': 'Datum auswählen',
  'booking.date': 'Datum',
  'booking.changedate': 'Datum ändern',
  'booking.airline': 'Fluglinien',
  'booking.departs': 'Abfahrt',
  'booking.arrives': 'Ankommen',
  'booking.duration': 'Dauer',
  'booking.travelclass': 'Klasse',
  'booking.priceperadult': 'Erwachsener Preis',
  'booking.priceperchild': 'Kinderpreis',
  'booking.priceperinfant': 'Preis für Kleinkinder',
  'booking.flightnumber': 'FLUG NR ',
  'booking.remainseat': 'bleibender Sitz',
  'booking.cost': 'Kosten',
  'booking.showmore': 'mehr anzeigen',
  'booking.birthyear': 'Geburtsjahr',
  'booking.birthmonth': 'Geburtsmonat',
  'booking.birthday': 'Geburtsdatum',
  'booking.passportno': 'Pass Nr',
  'booking.birthcountry': 'Geburtsland',
  'booking.passportcountry': 'Staatsangehörigkeit',
  'booking.passportexpireyear': 'Ablaufsjahr',
  'booking.passportexpiremonth': 'Ablaufsmonat',
  'booking.passportexpireday': 'Ablaufstag',
  'booking.completeform': 'Füllen Sie das Formular aus, um fortzufahren',
  'booking.changeavatar': 'Avatar ändern',
  'booking.passengerinfo': 'Passagierinformationen',
  'booking.isiranian': 'Iraner',
  'booking.othernationality': 'Andere Nationalität',
  'booking.perviousepassenger': 'Wählen Sie aus der Passagierliste',
  'booking.index': 'Index',
  'booking.primarytraveler': 'Primärer Reisender',
  'booking.adultinformation': 'Informationen für Erwachsene',
  'booking.childinformation': 'Untergeordnete Informationen',
  'booking.infantinformation': 'Säuglingsinformation',
  'booking.phone': 'Telefonnummer',
  'booking.totalprice': 'Gesamtpreis',
  'booking.stopcount': 'Stopp!',
  'booking.airplanetype': 'Flugzeug',
  'booking.international': 'International',
  'booking.domestic': 'Inländisch',
  'booking.notexist': 'nicht existiert',
  'booking.noavailableflight': 'keinen verfügbaren Flug',
  'booking.departurecities': 'Abfahrtsort',
  'booking.returncities': 'Rückkehr Stadt',
  'booking.departuredate': 'Abreisedatum',
  'booking.returndate': 'Rückflugdatum',
  'booking.departuretime': 'Abfahrtszeit',
  'booking.returntime': 'RRückkehr Zeit',
  'booking.paynow': 'jetzt bezahlen',
  'booking.sigin': 'Einloggen',
  'booking.signup': 'Anmelden',
  'booking.notregister': 'Nicht registrieren',
  'booking.elevatemembers': 'Mitglieder Erhöhung',
  'booking.departureflightinfo': 'Abreise Informationen',
  'booking.returnflightinfo': 'Rückgabeinformationen',
  'booking.previouspassenger': 'Bisherige Passagiere',
  'booking.hi': 'Hallo! ',
  'booking.travelwith': 'Sie reisen mit',
  'booking.ticket': 'Ihr Ticket wird in Kürze ausgestellt',
  'booking.successpayment': 'Ihre Zahlung war erfolgreich',
  'booking.previousepassengerlist': 'Vorherige Passagierliste',
  'booking.bookingflights': 'Flüge buchen',
  'booking.flightno': 'Flug Nr',
  'booking.child': 'Kind',
  'booking.infant': 'Säugling',
  'booking.male': 'Herr',
  'booking.female': 'Frau',
  'booking.departureflight': 'Abgehender Flug',
  'booking.returnflight': 'Rückflug',
  'booking.showticket': 'Fahrkarte',
  'booking.cancel': 'Stornieren',
  'booking.passengers': 'Passagiere',
  'booking.price': 'Preis',
  'booking.returnprice': 'Rückgabepreis',
  'booking.cancelstatus': 'Status',
  'booking.cancelreason': 'Warum möchten Sie Ihr Ticket stornieren?',
  'booking.personalproblem':
    'Persönliches Problem (basierend auf Fluglinienregeln)',
  'booking.airlineproblem': 'Flug wird von Fluggesellschaft storniert',
  'booking.flightproblem': 'Verzögerung oder Eile mehr als 2 Stunden',
  'booking.back': 'Zurück',
  'booking.nextstep': 'Nächster Schritt',
  'booking.cancelingrules': 'Regeln stornieren',
  'booking.wait': 'Warten Sie bitte  .....',
  'booking.flights': 'Flüge',
  'booking.cancelpayment': 'Ihre Transaktion ist fehlgeschlagen',
  'booking.refid': 'Ihr Tracking-Code lautet:',
  'booking.airport': 'Flughäfen',
  'booking.flighttime': 'Flugzeit',
  'booking.flightstopcount': 'Stoppt',
  'booking.morning': 'Morgen (0 bis 8)',
  'booking.noon': 'Mittag (8 bis 14)',
  'booking.afternoon': 'Nachmittag (14 bis 20)',
  'booking.sort': 'Sortierung',
  'booking.sortbyprice': 'Nach Preis',
  'booking.sortbytime': 'Zum Zeitpunkt',
  'booking.nonstop': 'Direkt',
  'booking.onestop': 'Ein Stop',
  'booking.morethanonestop': 'Mehr als ein Stop',
  'booking.origin': 'die Herkunft',
  'booking.destination': 'das Reiseziel',
  'booking.startdate': 'Anfangsdatum',
  'booking.enddate': 'Endtermin',
  'booking.search': 'Suchen',
  'booking.filter': 'Filter',
  'booking.agree': 'Einverstanden!',
  'booking.cancelrules': 'Regeln abbrechen',
  'booking.flightscount': 'Flüge gefunden',
  'booking.clearfilter': 'klar!',
  'booking.gifavatar': 'Gif Avatar',
  'booking.avatar': 'Avatar',
  'booking.notfound': 'Es wurde keine Stadt gefunden',
  'booking.nextyear': 'Nächstes Jahr',
  'booking.previousyear': 'Vorheriges Jahr',
  'booking.details': 'Einzelheiten',
  'booking.adultprice': 'Preis pro Erwachsener',
  'booking.sortby': 'Sortiere nach',
  'booking.bydescendingprice': 'Preis',
  'booking.byascendingduration': 'Dauer',
  'booking.bydescendingduration': 'Dauer',
  'booking.byascendingprice': 'Preis',
  'booking.bydescendingtime': 'Abfahrtzeit',
  'booking.byascendingarrivetime': 'Ankunftszeit',
  'booking.bydescendingarrivetime': 'Ankunftszeit',
  'booking.byascendingtime': 'Abfahrtszeit',
  'booking.bydescendingpoint': 'Punkt',
  'booking.byascendingpoint': 'Punkt',
  'booking.justthis': 'Nur',
  'booking.searchpassenger': 'YSuchen nach... ',
  'booking.edit': 'Bearbeiten',
  'booking.select': 'Wählen',
  'booking.gotoday': 'Heute gehen',
  'booking.pricedetail': 'Preis Details',
  'booking.passengertype': 'der Typ',
  'booking.fareprice': 'Fahrpreis',
  'booking.tax': 'Steuer',
  'booking.allairport': ' ( Alle Flughafen )',
  'booking.moneyunit': '(Alle Preise sind $)',
  'booking.noseatresult': 'kein Sitzplatz',
  'booking.today': 'Heute',
  'booking.terminal': 'Terminal',
  'booking.sumprice': 'Gesamtpreis',
  'booking.sameairport':
    "Bitte geben Sie die eindeutigen Flughäfen 'Von' und 'Nach' ein.",
  'booking.stopin': 'Halt machen in...',
  'booking.megaleapyearsale': 'Mega Leap Year Sale',
  'booking.planasunnyd1':
    'Planen Sie jetzt einen sonnigen Urlaub und sparen Sie mit',
  'booking.planasunnyd2': 'Super seltene Tarife 29% Rabatt.',
  'booking.restrictionsapply': 'Einschränkungen gelten',
  'booking.grabaseat': 'Nimmen Sie einen Platz',
  'booking.enjoywithbestfriends': 'Genießen Sie mit besten Freunden',
  'booking.helpafriendd1':
    'Helfen Sie einem Freund, sich von seinem Treueprogramm zu trennen',
  'booking.helpafriendd2': 'und Punkte sammeln',
  'booking.termsandconditionsapply': 'Geschäftsbedingungen gelten',
  'booking.bookhotels': 'Hotels buchen',
  'booking.booktours': 'Touren buchen',
  'booking.traveldate': 'Reise datum',
  'booking.traveldatetime': 'Reise datum',
  'booking.invoice': 'Rechnungs',
  'booking.totalamount': 'Gesamtpreis',
  'booking.showreserve': 'Reserve anzeigen',
  'booking.takeofffaster': 'Schneller abheben',
  'booking.earn10kpointsd1': 'Sammeln Sie mit einem IAM TOURIST 10.000 Punkte',
  'booking.earn10kpointsd2': 'Visa-Unterschriftkarte.',
  'booking.learnmore': 'mehr erfahren',
  'booking.getsetforamorerewardingexperienceonthegroundandinthesky':
    'Machen Sie sich mit der neuen IAM TOURIST Visa Unterschrift® Card auf eine lohnende Erfahrung vor Ort und am Himmel gefasst.',
  'booking.firstoneonfirstoneoff': 'Erster an, Erster aus',
  'booking.inahurry':
    "Sind Sie In Eile? Machen Sie eine 'B' -Linie für das Auto mit einem bevorzugten Sitz in der Hauptkabine zur Vorderseite des Flugzeugs, oder gönnen Sie sich vorrangige Sicherheit und steigen Sie gegen eine geringe Gebühr ein.",
  'booking.feeltheupgrade': 'Fühlen Sie das Upgrade.',
  'booking.travelinstylewithextralegroom':
    'Reisen Sie stilvoll mit mehr Beinfreiheit, vorrangigem Einsteigen und mehr Sicherheit in der Hauptkabine Select. Lebe es nach oben.',
  'booking.takethefasttrack': 'Nehmen Sie die schnellesten Spur.',
  'booking.breezethroughsecuritylikeyouowntheplace':
    'Browsen Sie durch die Sicherheit, als ob Sie den Ort mit TSA Pre besitzen. Erfahren Sie, wie Sie die Vorteile nutzen können.',
  'booking.corporaterewards': 'Mitarbeitsbelohnung',
  'booking.abetterflighttoyournextmeetingdoesn’thavetobeanextravagance':
    'Ein besserer Flug zu Ihrer nächsten Sitzung muss keine Extravaganz sein. Elevate, amtlich eingetragen, ist unser Mitarbeitsbelohnungsprogramm, mit dem Sie Ihrem Unternehmen etwas zurückgeben können, was Sie für Reisen ausgeben.',
  'booking.packyourpoints': 'Paacken Sie Ihre Punkte',
  'booking.livelargeat35,000feet':
    'Leben Sie groß bei 35.000 Fuß. Treten Sie Elevate bei und sammeln Sie Punkte, Vergünstigungen und Prämienflüge mit Nobblackout-Daten.',
  'booking.allpassengerprice': 'Gesamtpreis für alle Passagiere',
  'booking.baggages': 'Gepäck',
  'booking.orderdate': 'Bestelldatum',
  'booking.passengername': 'Name',
  'booking.cancelticket': 'Ticket canceln',
  'booking.operatedairline': 'Fluggesellschaft',
  'booking.count': 'Anzahl',
  'booking.departureflighttime': 'Abfahrtszeit',
  'booking.returnflighttime': 'Zeit der Rückkehr',
  'booking.returnstopcount': 'Rückkehrstoppt',
  'booking.pc': 'PC',
  'booking.kg': 'KG',
  'booking.cabin': 'Kabine',
  'booking.layoverairports': 'Zwischenstopp Flughäfen',
  'booking.includeairports': 'Flughäfen einbeziehen',
  'booking.departduration': 'Abfahrtsdauer',
  'booking.returnduration': 'Rückgabedauer',
  'booking.night': 'Nacht (nach 20)',
  'booking.nightcount': 'Nacht',
  'booking.nights': 'Nächte',
  'booking.showflightdetail': 'Flugdetails anzeigen',
  'booking.toman': 'IRT',
  'booking.free': 'kostenlos',
  'booking.hour': 'Stunde',
  'booking.minutes': 'Minute',
  'booking.and': 'und',
  'booking.nobaggage': 'Kein Gepäck',
  'booking.mainterminal': 'Hauptterminal',
  'booking.shamsi': 'Jalali-Kalender',
  'booking.miladi': 'Gregorianischer Kalender',
  'booking.adultageerror': 'Erwachsenenalter sollte mehr als 12 Jahre alt sein',
  'booking.childageerror':
    'Das Kindesalter sollte mehr als 2 Jahre und weniger als 12 Jahre betragen',
  'booking.infantageerror': 'Das Kindesalter sollte unter 2 Jahren liegen',
  'booking.passenger': 'Passagier',
  'booking.important': 'Wichtig',
  'booking.identifynote':
    'Der vollständige Name des Passagiers muss genau so in Englisch geschrieben sein, wie er auf dem Reisepass angegeben ist.',
  'booking.validpassportdate':
    'Das Ablaufdatum Ihres Reisepasses sollte mehr als 6 Monate betragen.',
  'booking.adt': 'ADT',
  'booking.chd': 'CHD',
  'booking.inf': 'INF',
  'booking.departure': 'Abteilung',
  'booking.return': 'Rückkehr',
  'booking.allflightinformation': 'Alle Fluginformationen',
  'booking.notavailable': 'nicht verfügbar',
  'booking.previousemonth': 'Letzer Monat',
  'booking.nextmonth': 'Nächster Monat',
  'booking.passportexpiredate': 'Ablaufdatum des Reisepasses',
  'booking.arrivein': 'Ankunft in',
  'booking.nextdays': 'Nächster Tag',
  'booking.clearallfilter': 'alles löschen',
  'booking.duplicatepassenger':
    'Der nationale Code oder die Passnummer wurde dupliziert',
  'booking.policy':
    'Klicken Sie hier, um anzuzeigen, dass Sie den Begriff gelesen haben und ihm zustimmen',
  'booking.changecontact': 'Ticketinformationen werden an gesendet : ',
  'booking.customeragreement': 'Kundenvereinbarung',
  'booking.flightrules': 'Flugregeln',
  'booking.changecontacttitle': 'die Kontaktinformationen ändern',
  'booking.fullname': 'Vollständiger Name',
  'booking.address': 'Adresse',
  'booking.change': 'ändern',
  'booking.firstname': 'Vorname',
  'booking.lastname': 'Nachname',
  'booking.departureairport': 'Abflugsflughafen',
  'booking.arrivalairport': 'Ankunftsflughafen',
  'booking.previousedays': 'Vorheriger Tag',
  'booking.day': 'Tag',
  'booking.month': 'Monat',
  'booking.year': 'Jahr',
  'booking.changepassenger': 'Die Anzahl der Passagiere ändern',
  'booking.editdepartcity': 'Ursprungsstadt bearbeiten',
  'booking.editdestinationcity': 'Zielstadt bearbeiten',
  'booking.editdepartdate': 'Ursprungsdatum bearbeiten',
  'booking.editdestinationdate': 'Zieldatum bearbeiten',
  'booking.changepassengernotify':
    'Wenn Sie in diesem Schritt den Passagier wechseln, kehren Sie zum Flugsuchschritt zurück!!!!',
  'booking.edittooltip':
    'Bitte klicken Sie auf die gewünschte Eigenschaft, um die Flugeigenschaften zu ändern ',
  'booking.books': 'Bucungen',
  'booking.reserves': 'Reserven',
  'booking.of': 'von',
  'booking.canceled': 'storniert',
  'booking.history': 'Verlauf',
  'booking.searchpassengerinfo':
    'Name, Passnummer, Ausweiscode, Bestellnummer, Ticketnummer, PNR',
  'booking.issued': 'ausgestellt',
  'booking.bought': 'ausgestellt',
  'booking.serviceType': 'Servicetyp',
  'booking.serviceName': 'Flug, Hotel, Zug ...',
  'booking.invoicenumber': 'Rechnungsnummer',
  'booking.chooseticket': 'Welches Ticket möchten Sie stornieren?',
  'booking.cancelreturn': 'Stornieren Sie nur die Rückfahrkarte',
  'booking.cancelroundtrip': 'Alle Tickets stornieren',
  'booking.addflight': 'Flug hinzufügen',
  'booking.showmulticity': 'Alle Flüge anzeigen',
  'booking.view': 'Aussicht',
  'booking.takeofffrom': 'Startzeit ab',
  'booking.at': 'Um',
  'booking.tripsi': 'Tripsi',
  'booking.includetax':
    'Der Preis beinhaltet Steuern und alle Kosten der Fluggesellschaft',
  'booking.paymentsummery': 'Zahlungsübersicht',
  'booking.counter': 'Schalter',
  'booking.sum': 'Summe',
  'booking.transaction': 'Überweisungsbericht',
  'booking.countercommission': 'Provisionsbericht des Schalters',
  'booking.domesticflightscount': 'Anzahl der Inlandsflüge',
  'booking.internationalflightscount': 'Anzahl der Internationalsflüge',
  'booking.createdate': 'Datum erstellen',
  'booking.income': 'Einkommen',
  'booking.notwithdrawincome': 'Einkommen nicht abheben ',
  'booking.notwithdrawpoint': 'Punkt nicht abheben',
  'booking.withdrableincome': 'Withdrable Income',
  'booking.withdrablepoint': 'Withdrable Point',
  'booking.pendingincome': 'Ausstehende Einnahmen',
  'booking.pendingpoint': 'Ausstehender Punkt',
  'booking.collectedpoint': 'Gesammelter Punkt ',
  'booking.spentpoint': 'Verbrauchter Punkt',
  'booking.paymentstatus': 'Zahlungsstatus',
  'booking.withdrawdate': 'Widerrufsrecht',
  'booking.countername': 'Name des Schalters',
  'booking.canceleditting': 'Abbrechen',
  'booking.nationalcode': 'National',
  'booking.previousweek': 'Letzte Woche',
  'booking.nextweek': 'Nächste Woche',
  'booking.allprice': 'Alle Preise sind in IRT',
  'booking.allpriceisrial': 'Alle Preise sind in IRR',
  'booking.showallcalendar': 'Matrixpreis anzeigen',
  'booking.hideallcalendar': 'hMatrixpreis ausblenden',
  'booking.multicitytrip': 'Mehrstädte reisen',
  'booking.selectstakeholder': 'Wählen Sie Ihren Interessenvertreter',
  'booking.changestakeholder': 'Interessenvertreter ändern',
  'booking.ticketwithoutprice': 'Ticket ohne Preis',
  'booking.markupticket': 'Ticket mit Preiserhöhung',
  'booking.orginalticket': 'Originalticket',
  'booking.markup': 'Preiserhöhung',
  'booking.removeflight': 'Flug entfernen',
  'booking.continueguest': 'Als Gast fortfahren',
  'booking.hotel': 'Hotel',
  'booking.trackorder': 'Bestellungen ',
  'booking.trackingcode': 'Verfolgenscode',
  'booking.searchyourorders': 'Ihre Bestellungen suchen',
  'booking.panel': 'Panel',
  'booking.required': 'erforderlich',
  'booking.baggagerules': 'Gepäckregeln',
  'booking.notresult': 'Verfolgenscode ist nicht gültig',
  'booking.userpoint': 'Derik Award',
  'booking.attachpassport': 'Pass hochladen ...',
  'booking.payhint': 'Bitte überprüfen Sie die Regeln, um fortzufahren',
  'booking.completecontactdescription':
    'Bitte kaufen Sie die Kontaktinformationen des Ticker-Emittenten aus.',
  'booking.swipeforthesky': 'Streichen Sie nach dem Himmel',
  'booking.downloadticket': 'Ticket herunterladen',
  'booking.withdrawtype': 'Typ zurückziehen',
  'booking.updatepassenger': 'Passagierinformationen aktualisieren',
  'booking.paylater': 'später bezahlen',
  'booking.pnr': 'PNR',
  'booking.penaltyprice': 'Strafpreis',
  'booking.sumcancelprice': 'Rückerstattbarer Gesamtbetrag',
  'booking.paymenttype': 'Zahlungsart',
  'booking.chargecredit': 'mein Guthaben aufladen',
  'booking.chargecreditinfo':
    'Der Betrag wird Ihrem Tripsi-Guthaben für bis zu 7 Werktage belastet.',
  'booking.deposit': 'Einzahlung auf Bankkarte',
  'booking.depositinfo':
    'Der Betrag wird bis maximal 7 Werktage auf das Bankkonto eingezahlt, von dem aus der Kauf getätigt wurde.',
  'booking.cancelmessage':
    'Ihre Stornierungsanfrage wurde erfolgreich eingereicht und ist im Gange',
  'booking.contactus':
    'Wenden Sie sich bei Problemen an das Support-Team von Tripsi',
  'booking.sendproblem': 'Problem senden',
  'booking.notrefundable': 'Nicht erstattbar',
  'booking.sendrequest': 'Anfrage senden',
  'booking.hours': 'Stunden',
  'booking.before': 'vor dem Flug',
  'booking.flight': 'Flug',
  'booking.exacttime': 'mittags',
  'booking.until': 'bis',
  'booking.afterflight': 'nach dem Flug',
  'booking.beforeflight': 'vor dem Flug',
  'booking.after': 'bis nach',
  'booking.fromhours': 'from',
  'booking.callsupport':
    'Bei der Ausstellung der Tickets ist ein Fehler aufgetreten. Bitte rufen Sie den Support an',
  'booking.nocancelrules': 'Flugregel nicht gefunden',
  'booking.andhigher': 'Und höher',
  'booking.toprice': 'Und höher',
  'booking.searchtimeout': 'Möchten Sie diesen Flug erneut suchen?',
  'booking.timeout': 'Suchzeit ...',
  'booking.searchagaininfo': 'Die Zeit, dies zu suchen',
  'booking.searchagaininfomsg': ' Flug wurde beendet',
  'booking.searchagian': 'Ja',
  'booking.startagain': 'Nein',
  'booking.printticket': 'Ticket drucken',
  'booking.retrivedocument': 'Dokument abrufen ...',
  'booking.forthepassenger': 'Für den Passagier',
  'booking.flightticket': 'Flugticket',
  'booking.ticketno': 'Ticket-Nr',
  'booking.deptime': 'dep Time',
  'booking.cancelterm':
    '1- Die Stornierungsbedingungen für CHARTER-Flüge hängen von den Regeln des Anbieters ab. Dies bedeutet, dass es niemals storniert werden kann.',
  'booking.cancelrulehint':
    '2- Peruutuskustannukset riippuvat lentoyhtiön säännöistä.',
  'booking.attention':
    'Achtung: Passagiere müssen 2 Stunden vor Abflug am Flughafen anwesend sein.',
  'booking.valididentify':
    '3- Bitte haben Sie gültige Ausweispapiere wie Personalausweis, Geburtsurkunde oder Reisepass bei sich.',
  'booking.online': 'online',
  'booking.selectcountry': 'Land auswählen',
  'booking.calendar': 'Kalender',
  'booking.countercommissionreport': 'Bericht der Gegenkommission',
  'booking.hasusername': 'Hast du einen Benutzernamen ?',
  'booking.nousername': 'Ich habe keinen Benutzernamen ?',
  'booking.signuporguest': '(Anmelde- oder Gastbenutzer)',
  'booking.guestuser': 'Gastbenutzer',
  'booking.notuserbefore': 'Jetzt anmelden und Punkte sammeln',
  'booking.reservationfail': 'Es ist nicht möglich, diesen Flug zu buchen',
  'booking.reservation':
    'Für diesen Flug ist eine temporäre Reservierung möglich',
  'booking.reservationerror': 'Reservierungsfehler!',
  'booking.passengererror': 'Passagierinformationsfehler! ',
  'booking.passengerInformationHint':
    'Bitte überprüfen Sie die Passagierinformationen...',
  'booking.displayticket': 'So zeigen Sie Tickets an',
  'booking.selectcustomer': 'Kunden auswählen',
  'booking.asacustomer': 'Kunden zuweisen',
  'booking.changeticketprice': 'Ticketpreisansicht ändern',
  'booking.save': 'sparen',
  'booking.fromwallet': 'Brieftasche',
  'booking.fromcredit': 'Anerkennung',
  'booking.frompoint': 'Punkt',
  'booking.usederik': 'Zahlen Sie den Ticketpreis mit Ihrem Derik',
  'booking.yourderik': 'Dein derik : ',
  'booking.equivalentprice': 'Äquivalenter Preis',
  'booking.importpnr': 'Import PNR',
  'booking.pnrhint': 'Wählen Sie Ihr System aus',
  'booking.pnrsteps':
    'Um PNR zu verwenden, führen Sie bitte diese Schritte aus',
  'booking.enteryour': '1- Enter to your Amadeus panel',
  'booking.openreference': '2- Make your reservation in Amadeus panel. ',
  'booking.passengerinfo':
    '3- Enter the passenger passport information completely. ',
  'booking.entercommand':
    '4-Enter the following command code and then press enter key. ',
  'booking.savepnr': '5-Save your PNR and press enter key. ',
  'booking.pnr6':
    '6- In Tripsi page, enter your PNR number in the reference number section. ',
  'booking.pnr7': '7- In the Passenger Last Name field, enter it. ',
  'booking.pnr8': '8- Click the booking button. ',
  'booking.pnr9': '9- Go to the payment page after checking the information. ',
  'booking.pnr10': '10- Your ticket has been issued. ',

  'booking.laststep':
    'Jetzt können Sie Ihre Referenz in das Feld unten eingeben und die Exportschritte ausführen.',
  'booking.leadlastname': 'Nachname des Hauptpassagiers',
  'booking.buyer': 'Käuferin',
  'booking.pnrnotfound': 'Keine Elemente gefunden',
  'booking.usepnr': 'PNR importieren und anzeigen',
  'booking.uploadpassporterror': 'Passinformationen sind nicht lesbar',
  'booking.servererror': 'Der Server hat ein Problem',
  'booking.accessdenied': 'Zugriff abgelehnt',
  'booking.newpassenger': 'Neuen Passagier hinzufügen',
  'booking.errormorepassenger': 'Sie haben mehr Passagiere gewählt',
  'booking.passengertypeerror': 'Ungültiger Passagiertyp',
  'booking.chooseallpassenger': 'Bitte wählen Sie alle Passagiere',
  'booking.checkpassport':
    'Überprüfen Sie nach dem Hochladen der Passdaten Ihre Daten',
  'booking.apply': 'anwenden',
  'booking.flightinformation': 'Fluginformationen',
  'booking.adultticketprice': 'Erwachsenenticket',
  'booking.childticketprice': 'Kinderticket',
  'booking.infantticketprice': 'Kinderticket',
  'booking.airplane': 'Flugzeug',
  'booking.time': 'Zeit',
  'booking.invoiceno': 'RechnungsNo',
  'booking.charter': 'Charta',
  'booking.systemic': 'Systemisch',
  'booking.type': 'Art',
  'booking.paymentprice': 'Zahlungspreis',
  'booking.pnrcode': 'Ihr PNR ist : ',
  'booking.selectpayment': 'Bitte wählen Sie die Zahlungsart',
  'booking.temporaryreservation': 'Reservierung',
  'booking.direction': 'Richtung',
  'booking.passengercount': 'Passagier zählt',
  'booking.reservesuccess': 'Ihr Ticket wurde vorübergehend gebucht',
  'booking.passengertotalprice': 'Gesamtpreis der Passagiere',
  'booking.stopduration': 'Stoppdauer',
  'booking.invalidbirthdate': 'ungültiges Geburtsdatum',
  'booking.invalidexpiredate': 'ungültiger Ablauftag',
  'booking.fullbirthdate': 'Geburtsdatum vollständig auswählen',
  'booking.fullexpiredate': 'Wählen Sie das Ablaufdatum vollständig aus',
  'booking.creditpayment': 'Die Zahlung von Ihrem Guthaben war erfolgreich',
  'booking.walletpatment': 'Die Zahlung aus Ihrer Brieftasche war erfolgreich',
  'booking.pointpayment': 'Die Zahlung von Ihrem Punkt war erfolgreich',
  'booking.tickettimelimit': 'Ticket-Zeitlimit',
  'booking.onbehalf': 'im Namen',
  'booking.expirereserve': 'Abgelaufen',
  'booking.person': 'Person',
  'booking.startorderdate': 'Bestelldatum starten',
  'booking.endorderdate': 'Bestelldatum beenden',
  'booking.missflight': 'Ich habe den Flug verpasst',
  'booking.multiairline': 'Multi Airline',
  'booking.in': 'in',
  'booking.afterdiscount': 'nach Rabatt',
  'booking.editissuer': 'Issue-Kontaktinformationen bearbeiten',
  'booking.referencenumber': 'Referenznummer',
  'booking.train': 'Zug',
  'booking.bus': 'Bus',
  'booking.economy': 'Wirtschaft',
  'booking.business': 'Unternehmen',
  'booking.first': 'Erste',
  'booking.allcabinclasses':
    'Auf Ihrer ausgewählten Route werden alle Flugklassen angezeigt.',
  'booking.findtrip': 'Reise finden',
  'booking.selectacity': 'Wählen Sie eine Stadt aus',
  'booking.destinations': 'Destinations',
  'booking.london': 'London',
  'booking.rome': 'Rom',
  'booking.istanbul': 'Istanbul',
  'booking.deletePassengerTitle': 'Passagier löschen',
  'booking.invalidnationalcode': 'Ungültiger nationaler Code',
  'booking.showgatewayerror': 'Gateway-Fehler anzeigen',
  'booking.alternativefrom': 'From',
  'booking.alternativeto': 'To',
  'booking.commingsoon': 'Bald',
  'booking.searchorigin': 'Herkunft suchen',
  'booking.searchdestination': 'Suchziel',
  'booking.plannedflight': 'Ihr ausgewählter Flug',
  'booking.yesterday': 'Gestern',
  'booking.twodaysago': 'Vor zwei Tagen',
  'booking.englishname': 'Vorname (Englisch)',
  'booking.englishlastname': 'Nachname (Englisch)',
  'booking.rialtotalprice': 'Gesamtpreis(Rial)',
  'booking.gotosearchflight': 'Zur Flugsuche',
  'booking.seat': 'Sitzplatz',
  'booking.englishticket': 'Englische Version von Tickets',
  'booking.persianticket': 'Persische Version des Tickets',
  'booking.searchmypassenger': 'Suche bei früheren Passagieren',
  'booking.selectairporterror': 'Wählen Sie Start- und Zielort von oben',
  'booking.providergateway': 'Provider-Gateways',
  'booking.seniorageerror': 'Seniorenalter sollte über 60 Jahre alt sein',
  'booking.toddlerageerror':
    'Das Alter des Kleinkindes sollte unter 2 Jahren liegen',
  'booking.noresultwithfilter':
    'Kein Ergebnis mit ausgewähltem Filter gefunden, bitte ändern Sie es',
  'booking.expirereservation': 'Abgelaufene Reservierung',
  'booking.unpaidreservation': 'unbezahlte Reservierungen',
  'booking.selectbooking': 'Bitte wählen Sie Tickets zum Bezahlen',
  'booking.mobileformaterror': 'Mobiles Format ist ungültig',
  'booking.mobileformaterror': 'Mobiles Format ist ungültig',
  'booking.poweredby': 'Powered by',
  'booking.hoteldescription': 'Buchen Sie jetzt Ihr Hotel mit 30% Rabatt',
  'booking.hoteldescription':
    '21-tägige Europatour für Nowruz 1401. Anmeldung bis Ende Dezember 5% Rabatt',
  'booking.parishotel': 'Paris Hotel',
  'booking.tickettitle': 'Ticket :',
  'booking.stopdurationin': 'Stoppdauer in',
  'booking.hoteldescription':
    '21-tägige Europatour für Nowruz 1401. Anmeldung bis Ende Dezember 5% Rabatt',
  'booking.contactInfo': 'Kontaktinformationen ausgeben',
  'booking.expireDate': 'Ablaufdatum',
  'booking.pnrdesc': 'Buchen Sie in Amadeus und geben Sie hier aus.',
  'booking.officeid': 'Büro-ID',
  'booking.pnrhelp': 'Benutzerhandbuch',
  'booking.ticketinfo': 'Kartendetails',
  'booking.saletotalamount': 'Gesamtverkaufsbetrag',
  'booking.emailticket': 'E-Mail-Ticket',
  'booking.changeticketprice': 'Preis ändern',
  'booking.backpreviouspage': 'Zurück zur vorherigen Seite',
  'booking.changecabinclass': 'Kabineklasse ändern',
  'booking.changecabinclassnotify':
    'Wenn Sie in diesem Schritt die Kabinenklasse ändern, gelangen Sie zurück zum Schritt Flugsuche !!!!',
  'booking.ticketprice': 'Ticket Preis',
  'booking.payableamount': 'bezahlbarer Betrag',
  'booking.showflight': 'Flug anzeigen',
  'booking.tripdirection': 'Reiserichtung',
  'booking.selectpaymenttype': 'Zahlungsart auswählen',
  'booking.title': 'Titel',
  'booking.mr': 'Herr.',
  'booking.mrs': 'Frau.',
  'booking.yourchoice': 'Ihre Wahl',
  'booking.result': 'Ergebnis',
  'booking.changeflight': 'Flugroute ändern',
  'booking.arrivetime': 'Ankunftszeit',
  'booking.sortbyarrivetime': 'Nach Ankunftszeit sortieren',
  'booking.sortbyduration': 'Nach Dauer sortieren',
  'booking.sortbypoint': 'Nach Punkt sortieren',
  'booking.tickettype': 'Tickettyp',
  'booking.selectall': 'Alle wählen',
  'booking.addpassenger': 'Beifahrer hinzufügen',
  'booking.textpassenger':
    'Über das untenstehende Formular können Sie die Informationen Ihres Passagiers eingeben und die Informationen am Ende registrieren.',
  'booking.showavailableflight': 'Verfügbare Flüge anzeigen',
  'booking.roomtype': 'kamertype',
  'booking.extrabed': 'Extra Bed',
  'booking.numberofrooms': 'Aantal kamers',
  'booking.addnewroom': 'Voeg een nieuwe kamer toe',
  'booking.picturesofroom': "Foto's van de kamer",
  'booking.availsflight': 'Verfügbarer Flug',
  'booking.events': 'Ereignisse im Kalender',
  'booking.eventsinfo': 'Veranstaltungen jedes ausgewählten Landes anzeigen',
  'booking.want': 'I wanna',
  'booking.setmaxprice': 'Maximalpreis festlegen',
  'booking.selectcity':
    'Bitte wählen Sie zuerst den Abflug- und Zielflughafen aus',
  'booking.allcabinselected':
    'Bei Inlandsflügen werden alle Flugklassen durchsucht',
  'booking.all': 'Alle',
  'booking.passportImage': 'Passbild',
  'booking.passporthint':
    'Bitte laden Sie das Bild deutlich und dem Muster entsprechend in der Größe 700*500 hoch',
  'booking.showsample': 'Beispielpass ansehen',
  'booking.originCity': 'Herkunftsstadt',
  'booking.destinationCity': 'Zielort',
  'booking.welcometripsi': 'Willkommen bei Tripsi',
  'booking.PassengerNameInEnglish': 'Passagiername auf Englisch',
  'booking.PassengerLastNameInEnglish': 'Nachname auf Englisch',
  'booking.NationalityOfThePassenger': 'Nationalität des Passagiers',
  'booking.genderOfThePassenger': 'Geschlecht des Passagiers',
  'booking.totalpriceofpassengers': ' Gesamtpreis des Passagiers ',
  'booking.travelerdetails': 'Details zum Reisenden',
  'booking.senior': 'Senior',
  'booking.toddler': 'Kleinkind',
  'booking.tourdescription':
    '21-tägige Europatour zum Nouruz 1401. Anmeldung bis Ende Dezember 5% Rabatt',
  'booking.reservebefore': 'diesen Flug reservieren vor',
  'booking.editpassengersinfo': 'Passagierinformationen bearbeiten',
};
